// middleware/require-verification.ts
import { useLegitimuzStatusStore } from '@/stores/legitimuz-status';
import { useUiStore } from '@/stores/ui';
import { useAuthStore } from '@/stores/auth';

enum ProtectedRoutes {
  PLAY = '/play',
  SPORTS = '/sports',
  CASINO = '/casino'
}


const isProtectedRoute = (path: string): boolean => {
  return Object.values(ProtectedRoutes).some(prefix => 
    path === prefix || path.startsWith(`${prefix}/`)
  );
};

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (!import.meta.client) return;


  const legitimuzStore = useLegitimuzStatusStore();
  const uiStore = useUiStore(); 
  const authStore = useAuthStore();

  if (!isProtectedRoute(to.path) || !authStore.user) {
    return;
  }
  
  const isApproved = await legitimuzStore.checkStatus(true); 
  
  if (!isApproved) {
    uiStore.showVerificationModal = true;
    return abortNavigation();
  }
});